// @flow
import moment from 'moment';

export const isRecertLate = ({
  recertDue = '',
  recertRange,
}: {
  recertDue?: string,
  recertRange?: string,
} = {}): boolean => {
  if (recertRange !== undefined) {
    return recertRange === 'lateRecerts';
  }

  const today = moment().startOf('day');
  const recertDueMoment = moment(
    recertDue,
    ['MM/DD/YYYY', 'YYYY-MM-DD', moment.ISO_8601],
    true,
  ).startOf('day');

  if (!recertDueMoment.isValid()) {
    return false;
  }

  const lastDayToCertify = recertDueMoment
    .clone()
    .subtract(1, 'months')
    .endOf('month');

  return today.isAfter(lastDayToCertify);
};
